import type React from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

const queryClientV5 = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      staleTime: 5 * 60 * 1000, // 5 minutes
      retry: 1,
    },
  },
});

export function QueryProviderV5({ children }: { children: React.ReactNode }): JSX.Element {
  return <QueryClientProvider client={queryClientV5}>{children}</QueryClientProvider>;
}
